import { FormHelperText } from '@mui/material';

export default function GlobalHelperTextFormik({ formik, name }) {
  return (
    <>
      {formik.touched?.[name] && Boolean(formik.errors?.[name]) && (
        <FormHelperText error>{formik.errors?.[name]}</FormHelperText>
      )}
    </>
  );
}
